import { faTv } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faFilm } from '@fortawesome/free-solid-svg-icons';
import { faVideo, faHardDrive, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useState } from 'react';
import Select from 'react-select';
import { deleteVideo } from '../../../../../api';
import Player from '../../../../../common/Player';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { swalConfig, toastConfig } from '../../../../../config';
import { toast } from 'react-toastify';
import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const Episode = ({ data, currentPath, serverId, removeVideo }) => {
  const mySwal = withReactContent(Swal);
  const [assigning, setAssigning] = useState(false);

  const [options, setOptions] = useState({
    controls: true,
    autoplay: false,
    sources: { src: data.url },

    poster: data.url.replace('.com/videos/', '.com/thumbnails/').replace('.mp4', '.jpeg'),
    updated: false,
  });

  const handleDelete = async () => {
    const res = await mySwal.fire({ ...swalConfig.confirm, text: `Estás borrando "${data.name}"` });
    if (res.isConfirmed) {
      const filePath = currentPath.join('/');
      const filename = data.name;

      deleteVideo({ serverId, filename, filepath: filePath }).then(() => {
        toast.success('Video borrado', toastConfig);
        removeVideo(data.name);
      });
    }
  };

  const cancelAssign = () => {
    setAssigning(false);
  };

  return (
    <div className='flex md:flex-row flex-col items-center gap-5 p-2 rounded-lg bg-red-2 bg-opacity-5 hover:ring-1 transition-all font-semibold w-full'>
      <div className='aspect-video min-w-[200px] max-w-[200px] rounded-xl overflow-hidden'>
        {options?.sources && <Player options={options} onReady={() => {}} style={{ fontSize: '10px' }} />}
      </div>
      <div className='w-full flex flex-col gap-3 text-lg mt-0 mb-auto font-thin text-red-1 overflow-hidden'>
        <div className='flex flex-wrap w-full gap-3'>
          <div className='flex items-center bg-white p-2 rounded-lg'>
            <FontAwesomeIcon icon={faHashtag} />
            &nbsp;
            <span>Temporada&nbsp;</span>
            <span className='font-semibold'>{data.temporada}</span>
          </div>

          <div className='bg-white p-2 rounded-lg'>
            <FontAwesomeIcon icon={faHashtag} />
            &nbsp;
            <b>Episodio&nbsp;</b>
            <span className='font-semibold'>{data.numero}</span>
          </div>

          <div className='bg-white p-2 rounded-lg'>
            <FontAwesomeIcon icon={faEye} />
            &nbsp;
            <b>Visitas&nbsp;</b>
            <span className='font-semibold'>{data.visitas}</span>
          </div>

          {data.uploadedAt && (
            <div className='bg-white p-2 rounded-lg'>
              <FontAwesomeIcon icon={faClock} />
              &nbsp;{new Date(data.uploadedAt).toISOString().slice(0, 10)}
            </div>
          )}
          <div className='bg-white p-2 rounded-lg overflow-hidden whitespace-nowrap overflow-x-auto'>
            <FontAwesomeIcon icon={faVideo} />
            &nbsp;
            <b>Video&nbsp;</b>
            <span className='font-semibold truncate'>{data.url}</span>
          </div>
        </div>
        <div className='flex gap-3 w-full'></div>
      </div>
    </div>
  );
};

export default Episode;
